export enum LegendType {
  Enum,
  Ranges,
  Mapped
}